import { render, staticRenderFns } from "./AllowBlockList.vue?vue&type=template&id=139e377c&scoped=true&"
import script from "./AllowBlockList.vue?vue&type=script&lang=ts&"
export * from "./AllowBlockList.vue?vue&type=script&lang=ts&"
import style0 from "./AllowBlockList.vue?vue&type=style&index=0&id=139e377c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e377c",
  null
  
)

export default component.exports